export const notifyError = (thisVue, message) => {
  thisVue.$vs.notify({
    text: message,
    color: "danger",
    iconPack: "feather",
    icon: "icon-alert-circle",
    time: 10000,
    position: "bottom-left",
  });
}

export const notifyErrorsFromServer = (thisVue, err) => {
  if (err && err.response) {
    const { errors } = err.response.data;
    errors.forEach((error) => {
      if (
        error.message &&
        error.message.indexOf("'Caravanista' inexistente") > 0
      ) {
        tryAgain = false;
        thisVue.$vs.notify({
          text: `Link para cadastro inválido!`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
          time: 10000,
          position: "bottom-left",
        });
      } else if (error.message) {
        thisVue.$vs.notify({
          text: error.message,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
          time: 10000,
          position: "bottom-left",
        });
      }
    });
  }
}